/**
 * get the right price depend on unit. Return the first match between unit of invoice and sale price
 *
 * @param {Object} price - contains price object with sale and invoice data
 * @param {string} type - type of price to return (customer_price, public_price, weee_amount)
 * @param {string} unit - unit to test with invoice and sale unit
 * @returns {number}
 */
function priceAdapter({ price, type }) {
  if (price) {
    return price[type];
  }
  return null;
}

export default priceAdapter;
